import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import Paragraph from 'antd/es/typography/Paragraph';
import { Row, Col, } from 'antd';
import TranslatedText from "translations/TranslatedText";

export default function Score(props) {
  const {
    score,
    numQuestions,
  } = props;

  let message;
  if (score >= 0 && score <= 7) {
    message = "Ouch! It's time to get to know more about China!";
  } else if (score >= 8 && score <= 14) {
    message = "It's a good start! Discover China more! Come on!💪";
  } else if (score >= 15) {
    message = "You are approaching China Expert level ! Yeah!✌";
  }

  return (
    <Paragraph>
      <Row type="flex" justify="center">
        <Col>
          <Text style={{ fontWeight: 250, fontSize: '2em', color: 'black' }} type="primary">
            <TranslatedText id="student.message.finished.score" />
          </Text>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col>
          <Title level={3}>
            {`${score}/${numQuestions}`}
          </Title>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col>
          <Title level={3}>
            {message}
          </Title>
        </Col>
      </Row>
    </Paragraph>
  )
}